import {z} from 'zod'
import axios from '@/axiosInstance.ts'
import {useAuthStore} from '@features/user/store/store.ts'

export const HttpGetIssueDateParams = z.object({
    entityId: z.coerce.number().int(),
    media: z.string()
})
export type HttpGetIssueDateParams = z.infer<typeof HttpGetIssueDateParams>

export const httpGetIssueDate = (params: HttpGetIssueDateParams) => {
    const accessToken = useAuthStore.getState().accessToken
    const url = `/chatbot/entities/${params.entityId}/${params.media}/pullPaymentDate`
    return axios.get(url, {headers: {Authorization: `Bearer ${accessToken}`}})
}
